// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"2bca6743","529":"e305cbbc","797":"508e968a","880":"15b74046","899":"380bee4f"}[chunkId] + ".chunk.css";
};